import {
    COLUMN_NAME,
    COLUMN_UNIQUE_IDENTIFIER,
    COLUMN_SITE,
} from "../../constants/column-types";
import {
    FILTER_SITES,
} from "../../constants/filter-types";
import LookupTypes from "../LookupTypes";
import { TableColumn } from "../table/TableColumn";

const AccessGroupOssDeviceColumns : TableColumn[] =[
    {
        heading: "Name",
        accessor: "name",
        isNumeric: false,
        id: 0,
        sortByName: "ossDevice.ossdName",
        sortDirection: "asc",
        active: true,
        translationKey: "name",
        isDefault: true,
        columnId: COLUMN_NAME,
    },
    {
        heading: "Door Id / Door Group Id",
        accessor: "ossdDeviceId",
        isNumeric: false,
        id: 1,
        sortByName: "ossDevice.ossdDeviceId",
        sortDirection: "asc",
        active: true,
        translationKey: "ossDoorIdOrGroupId",
        columnId: COLUMN_UNIQUE_IDENTIFIER,
    },
    {
        heading: "Site",
        accessor: "site",
        isNumeric: false,
        id: 3,
        sortByName: "ossDevice.site",
        searchOnName: "ossDevice.site.id",
        sortDirection: "asc",
        lookupName: LookupTypes.site,
        active: true,
        translationKey: "site",
        filterId: FILTER_SITES,
        columnId: COLUMN_SITE,
        settingDataName: "site",
    },
];

export default AccessGroupOssDeviceColumns;
